import { MainV3ApiBase } from './base';
import { EditableUser } from '../containers/application/states/UserFormState';
import { OrderIndexView } from '../types/orders';
import { LocationId } from '../../commonv3/types/locations';
import { MulticreatorPackageId } from '../../commonv3/types/multicreator_packages';
import { SessionId } from '../../commonv3/types/sessions';

export type MulticreatorApplicationRequest = {
  user?: EditableUser;
  card?: { token: string };
  entrance_installments: number;
  effective_date?: string;
  coupon_code?: string;
  home_location_id?: LocationId;
  application_package_id: MulticreatorPackageId;
  application_intermediate_review_session_id: SessionId;
  application_final_review_session_id: SessionId;
  application_initial_coaching_session_id: SessionId;
};

export type ApplicationPageResponse = {
  orders: OrderIndexView[];
};

export const MulticreatorApplicationApis = {
  base() {
    return MainV3ApiBase.appendPath('multicreator_applications');
  },
  apply(request: MulticreatorApplicationRequest): Promise<ApplicationPageResponse> {
    return this.base().appendPath('apply').post(request);
  },
};
